import React from "react";
import {Link} from "react-router-dom";
import {Row, Col, Image, Popover} from "antd";
import api from "../../utils/api";
import Svg from "../../components/Svg";
import './index.sass'
import qs from "../../utils/qs";
import {MERCHANT_STATE} from "../../store/merchant";
import {connect} from "react-redux";
import {TOKEN_STATE} from "../../store/token";

class Home extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            treaty: [],
            commune_list: [],
            tongji: null,
            search: props.location.search
        }
    }

    async componentDidMount() {
        this.init();
    }

   init () {
        this.getCommuneList();//获取我的圈子列表
        this.getGbList();
        this.getSumOrderAmount();
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (this.props.token.value !== nextProps.token.value && nextProps.token.value) {
            this.init();
        }
        return true;
    }

    getSumOrderAmount = async () => {//获取后台首页销售总金额
        let res = await api('sum-order-amount-by-merchant');
        if (res['code'] === 200) {
            this.setState({
                tongji: res['data']
            })
        }
    }


    getGbList = async () => {//获取团购列表

        let res = await api('gb-list')

        if (res.code === 200) {
            res.data.map((v) => {
                v['dis_pub'] = qs.distanceNow(v.publish_time, 'start');
                v['pro_img'] = [];

                let {details} = v;
                if (details && details instanceof Array) {
                    for (let i in details) {
                        if (details[i]['type'] === 'bigImage') {
                            v['pro_img'].push(details[i]['value'])
                        }
                        if (details[i]['type'] === 'smallImage') {
                            v['pro_img'] = v['pro_img'].concat(details[i]['value'])
                        }
                    }
                }
            })


            this.setState({
                treaty: res.data
            })
        }
    }


    getCommuneList = async () => {//圈子列表
        let res = await api('get-commune-list', {})
        if (res.code === 200) {
            this.setState({
                commune_list: res.data
            })
        }
    }

    render() {
        let {treaty, commune_list, tongji} = this.state
        return (

            <div className='home'>
                {/* 头部 */}
                <div className='userInfo'>
                    <p>首页</p>
                    <div className='flex user_data'>
                        <div className='user_left flex'>
                            <div className='user_avatar'>
                                <Image src={this.props.merchant.avatar}/>
                            </div>
                            <div className='words'>
                                <p className='welcome'>{qs.timeWord().area}，{this.props.merchant.name} ，{qs.timeWord().txt}</p>
                                <div className='flex wish'>
                                    <label>每日寄语 | </label>
                                    <p> 人类追求卓越的最高奖赏，不是你得到什么！而是成为什么！</p>
                                </div>
                            </div>
                        </div>
                        <div className='user_right'>
                            {
                                tongji ? (<ul className='flex census'>
                                    <li>
                                        <label>进行中的团购</label>
                                        <p>{tongji['gb_num']}</p>
                                    </li>
                                    <li>
                                        <label>进行中的合约</label>
                                        <p>{tongji['contract_num']}</p>
                                    </li>
                                    <li>
                                        <label>今日总销售额</label>
                                        <p>￥{tongji['total_amount']}</p>
                                    </li>
                                </ul>) : null
                            }

                        </div>
                    </div>

                </div>

                {/* 数据 */}

                <div className='record'>
                    <Row>
                        <Col span='18'>
                            <div className='record-left'>
                                <div className='flex treaty'>
                                    <div className='title flex'><Svg.book className='svg'/> 进行中的团购/合约</div>
                                    <Link className='link' to='/group/groupsList'>全部项目 &gt;</Link>
                                </div>
                                <ul className='flex treaty_list'>
                                    {
                                        treaty.map((v, index) => {
                                            return (index < 8 ? (
                                                <li className='treaty_li' key={index}>
                                                    <p className='title'>
                                                        {v.name}
                                                    </p>
                                                    <p className='flex alignCenter seemore'>
                                                        <span className='cansee'>可见对象：高新区专卖群、经开区...</span>
                                                        <Popover content={(<div></div>)} title="更多可见对象" trigger="hover">
                                                            <span className='themeColor pointer'>更多</span>
                                                        </Popover>

                                                    </p>
                                                    <ul className='imgs flex'>
                                                        {
                                                            v['pro_img'].map((item, index) => {
                                                                return (
                                                                    <li key={index}>
                                                                        <Image src={item}/>
                                                                    </li>
                                                                )
                                                            })
                                                        }
                                                    </ul>
                                                    <p className='flex aglinCenter seeTreatyData'>
                                                        <Link className='seemoredata'
                                                              to={'/group/groupsDetail?id=' + v.id}>查看合约数据</Link>
                                                        {
                                                            v.dis_pub ? (
                                                                <span
                                                                    className='publishTime'>{Math.abs(v.dis_pub.d)} 天 {Math.abs(v.dis_pub.h)}小时前发布</span>

                                                            ) : null
                                                        }
                                                    </p>
                                                </li>
                                            ) : null)
                                        })
                                    }
                                </ul>
                            </div>
                        </Col>
                        <Col span='6'>
                            <div className='record-right'>
                                <div className='box'>
                                    <div className='title flex alignCenter'>
                                        <Svg.quick className='svg'/>
                                        <p>快速开始/便携导航</p>
                                    </div>
                                    <div className='content'>
                                        <div className='flex alignCenter quickHref'>
                                            <Link className='link' to='/user/userList'>用户列表</Link>
                                            <Link className='link' to='/group/groupsList'>团购列表</Link>
                                            <Link className='link' to='/order/ordersList'>订单列表</Link>
                                            <Link className='link' to='/goods/goodsList'>创建商品</Link>
                                            <Link className='link' to='/finance/merchant'>商户进件</Link>
                                        </div>
                                    </div>
                                </div>

                                <div className='box'>
                                    <div className='title flex alignCenter'>
                                        <Svg.deal className='svg'/>
                                        <p>最近七天交易额</p>
                                    </div>
                                    <div className='content'>
                                    </div>
                                </div>

                                <div className='box'>
                                    <div className='title flex alignCenter'>
                                        <Svg.deal className='svg'/>
                                        <p>我的圈子</p>
                                    </div>
                                    <div className='content'>
                                        <div className='flex alignCenter ring'>
                                            {
                                                commune_list.map((v, index) =>
                                                    <div key={index}>
                                                        <Link className='link' to="">
                                                            <Image src={v.avatar} className='avatar'/> {v.name}
                                                        </Link>
                                                    </div>
                                                )
                                            }
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (store) => {
    return {
        merchant: store[MERCHANT_STATE],
        token:store[TOKEN_STATE]
    }
};
export default connect(mapStateToProps)(Home);